export default "__VITE_ASSET__NSipFHIR__"